export interface PageListItem {
  id: number;
  name: string;
  hidden: boolean;
  created_at: string;
  updated_at: string;
}

export interface PageSearchResultItem {
  id: number;
  type: string;
  name: string;
  hidden: boolean;
  locked?: boolean;
  url: string;
  matching_chunk: string;
  score: number;
}

export interface Tab {
  name: string;
  hidden: boolean;
  order: number;
  uid: string;
  url: string;
  content: string;
}

export interface PageStatus {
  id: string;
  name: string;
}

export interface CoverShortcutTile {
  title: string;
  description: string;
  url: string;
  page_id?: number;
  image_url?: string;
}

export interface Page {
  id: number;
  uid: string;
  slug: string;
  url: string;
  name: string;
  introduction: string;
  hidden: boolean;
  locked: boolean;
  created_at: string;
  updated_at: string;
  status: PageStatus | null;
  tabs?: Tab[];
  content?: string;
  cover_shortcut_tiles?: CoverShortcutTile[];
  content_images_valid_until?: string;
  content_attachments_valid_until?: string;
}
